// extracted by mini-css-extract-plugin
export default {"nonFullscreen":"DGYR6fDp","mainContentContainer":"_EXy7mbb","mainContentFadeIn":"IdgNe7qm"};